import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=3b6289dd&scoped=true&"
import script from "./TeamMembers.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamMembers.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TeamMembers.vue?vue&type=style&index=0&id=3b6289dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6289dd",
  null
  
)

export default component.exports